var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "table",
        {
          ref: "headerTable",
          staticClass:
            "tabular-header v-datatable v-table v-datatable--select-all theme--light",
        },
        [
          _c("thead", [
            _c(
              "tr",
              { staticClass: "virtual-scroll-table__header" },
              [
                _vm.checkbox
                  ? _c("th", { attrs: { width: _vm.hardCodedSelectWidth } }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "v-input v-input--selection-controls v-input--checkbox v-input--hide-details theme--light",
                          attrs: { primary: "" },
                        },
                        [
                          _c("div", { staticClass: "v-input__control" }, [
                            _c(
                              "div",
                              { staticClass: "v-input__slot" },
                              [_c("v-checkbox")],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.headers, function (header, index) {
                  return [
                    _vm.disableSlicedHeaders
                      ? [
                          _c(
                            "th",
                            {
                              key: `th-${index}`,
                              style: _vm.getMaxWidth(
                                header.text,
                                _vm.getHeader(index)
                              ),
                            },
                            [_vm._v(_vm._s(header.text))]
                          ),
                        ]
                      : _c("SlicedHeader", {
                          key: `th-${index}`,
                          ref: "slicedHeaders",
                          refInFor: true,
                          attrs: {
                            headerStyle: _vm.getMaxWidth(
                              header.text,
                              _vm.getHeader(index)
                            ),
                            header: header,
                            sortable: !!header.sorter,
                            active: _vm.isActiveSort(header),
                            descending: _vm.sort.descending,
                            data: _vm.items,
                            disabled: _vm.isLoading || _vm.isSaving,
                            slowMode: _vm.slowMode,
                          },
                          on: {
                            slice: function ($event) {
                              return _vm.onSlice()
                            },
                            sort: function ($event) {
                              return _vm.onSort(header)
                            },
                          },
                        }),
                  ]
                }),
                _vm._v(" "),
                _c("th", { style: { width: _vm.scrollWidth + "px" } }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm._t(
            "no-data",
            function () {
              return [
                _c(
                  "v-alert",
                  {
                    attrs: {
                      type: "warning",
                      value: _vm.noData && !_vm.isLoading,
                    },
                  },
                  [
                    _vm._v(
                      "Oops, there's no data to show. This shouldn't be happening -\n        please let us\n        know."
                    ),
                  ]
                ),
              ]
            },
            { noData: _vm.noData, isLoading: _vm.isLoading }
          ),
          _vm._v(" "),
          _vm.isLoading
            ? _c(
                "tbody",
                {
                  style: `display: block; height: ${_vm.optimalTableHeight}px;`,
                  attrs: { "data-ui-component": "skeletonLoaders" },
                },
                _vm._l(_vm.skeletonDataItems, function (i) {
                  return _c(
                    "div",
                    {
                      key: `row-${i}`,
                      staticClass: "cell-container",
                      staticStyle: { height: "48px" },
                    },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "row" },
                        [
                          _vm._l(_vm.headers, function (header, index) {
                            return [
                              _c(
                                "v-flex",
                                {
                                  key: `cell-${index}`,
                                  class: `cell cell${header.value}`,
                                  style: _vm.getMaxWidth(
                                    header.text,
                                    _vm.getHeader(index)
                                  ),
                                  attrs: { id: `cell${header.value}` },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "loading-skeleton-1" },
                                    [_vm._v(_vm._s(header.text))]
                                  ),
                                ]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "VirtualList",
            {
              ref: "bodyTable",
              staticClass:
                "v-datatable v-table v-datatable--select-all theme--light no-x-scroll",
              attrs: {
                size: _vm.rowHeight,
                remain: _vm.numberOfRowsToDisplay,
                rtag: "table",
                wtag: "tbody",
              },
            },
            _vm._l(_vm.items, function (row, i) {
              return _c(
                "tr",
                {
                  key: `data-row-${i}`,
                  staticClass: "virtual-scroll-table__row",
                  on: { click: _vm.onVirtualListClick },
                },
                [
                  _vm.checkbox
                    ? _c("td", { attrs: { width: _vm.hardCodedSelectWidth } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "v-input v-input--selection-controls v-input--checkbox v-input--hide-details theme--light",
                            attrs: { primary: "" },
                          },
                          [
                            _c("div", { staticClass: "v-input__control" }, [
                              _c(
                                "div",
                                { staticClass: "v-input__slot" },
                                [_c("v-checkbox")],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.headers, function (header, j) {
                    return _c(
                      "td",
                      {
                        key: `td-row_${i}-col_${j}`,
                        staticClass: "virtual-scroll-table__cell",
                        style: _vm.getMaxWidth(header.text, _vm.getHeader(j)),
                        attrs: { id: _vm.formatCellId(header, row.data) },
                      },
                      [
                        _vm._t(
                          "default",
                          function () {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.accessItemValue(header, row.data)
                                  ) +
                                  "\n        "
                              ),
                            ]
                          },
                          { header: header, row: row }
                        ),
                      ],
                      2
                    )
                  }),
                ],
                2
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }